import { UserRoles } from '../enums/user-roles.enum';

export interface IGuardPermissions {
  [name: string]: UserRoles[];
}
